import * as React from 'react';
import { Dropdown, Button } from 'antd';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { componentShouldBeDisplayed, localStorageHelper, projectDetection } from 'utils';
import { Link } from 'react-router-dom';
import SearchComponent from 'Components/SearchComponent/SearchComponent';
import * as i18next from 'i18next';
import { LogoutOutlined, SettingOutlined, UserOutlined, DownCircleOutlined } from '@ant-design/icons';
import { logout } from 'redux/actions/user-actions';
import { MenuProps } from 'antd';
import { Header } from 'antd/lib/layout/layout';

const MainHeader: React.FC = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const handleLogout = () => {
        dispatch(logout());
    };

    const getUserMenuItems = (t: i18next.TFunction): MenuProps['items'] => [
        ...(componentShouldBeDisplayed('settingsLink')
            ? [
                  {
                      key: 'settings',
                      label: (
                          <Link
                              id="button_settings"
                              className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100"
                              to={`/casino/settings`}
                          >
                              <SettingOutlined className="text-gray-600" />
                              {t('settings')}
                          </Link>
                      ),
                  },
              ]
            : []),
        {
            key: 'logout',
            label: (
                <div
                    id="button_logout"
                    className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={handleLogout}
                >
                    <LogoutOutlined className="text-gray-600" />
                    {t('log_out')}
                </div>
            ),
        },
    ];

    const getNameForDropdown = () => {
        const name = localStorageHelper.getChainedValue('user.name') || '';
        const maxNameLength = 100;

        if (name.length > maxNameLength) {
            return `${name.substring(0, maxNameLength)}...`;
        }

        return name;
    };

    return (
        <Header style={{position: 'sticky', top: 0}} className="flex items-center justify-between px-6 py-4 bg-white border border-gray-200 border-l-0 z-10">
            {projectDetection.isBO() && <div className="w-2/5 flex items-center"><SearchComponent /></div>}
            <div className="flex items-center">
                <Dropdown
                    menu={{ items: getUserMenuItems(t) }}
                    placement="bottomLeft"
                    trigger={['click']}
                >
                    <Button
                        className="flex items-center gap-2"
                        title={localStorageHelper.getChainedValue('user.name') || ''}
                    >
                        <UserOutlined />
                        {getNameForDropdown()}
                        <DownCircleOutlined />
                    </Button>
                </Dropdown>
            </div>
        </Header>
    );
};

export default MainHeader;
